module.exports = ".remove-rule-dialog {\n  width: 400px;\n  padding: 5px; }\n  .remove-rule-dialog h3 {\n    margin-top: 0;\n    margin-bottom: 16px;\n    text-align: center;\n    font-weight: 300; }\n  .remove-rule-dialog button {\n    margin-right: 8px; }\n  .remove-rule-dialog button:last-of-type {\n      margin-right: 0; }\n  .remove-rule-dialog .btn-container {\n    width: 50%;\n    margin: 0 auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/business-rules/remove-rule-dialog/remove-rule-dialog.component.scss
// module id = ./src/app/modules/business-rules/remove-rule-dialog/remove-rule-dialog.component.scss
// module chunks = main